module.exports = __webpack_public_path__ + "static/media/bonusu_rats_3_min.e738fcc2.png";